$(document).ready(function(){
    $(document).on('click', '.add_extra_prd_btn', function(){
        $(this).next().addClass('open');
    });
    $(document).on('click', '.add_extra_product_popup_inner span.close_btn', function(){
        $('.add_extra_product_popup_main').removeClass('open');
    });
    $(document).on('click', '.add_extra_product_popup .option_name', function(){
        setTimeout(() => {
            $(this).next().addClass('open');
        }, 500);
        
    });
    $(document).on("click", function (e) {
    if ($(e.target).closest(".option_value_box").length === 0) {
        $('.option_value_box').removeClass('open');
    }
    });
    $(document).on('click', '.option_value_box .option_value', function(){
       $(this).closest('.option_box').find('.option_value.active').removeClass('active');
       $(this).addClass('active');
       var getValue = $(this).attr('value');
       $(this).closest('.option_box').find('.option_name').addClass('selected').text(getValue).removeClass('borderred');;
       $(this).closest('.option_value_box').removeClass('open');

       let allSelected = true;
        var pleaseSelect;
        let selectedOptions = [];
        var finalselectedid;

        var finalSelect = $(this).closest('.add_extra_product_single').find('.add_extra_prd_btn');
        var singlePopup = $(this).closest('.add_extra_product_popup_main');
        var pricebox = $(this).closest('.add_extra_product_popup_main').find('.price_extraprdadd');
        $(this).closest('.add_extra_product_popup_main').find('.option_name').each(function () {
            if (!$(this).hasClass('selected')) {
                allSelected = false;
                var thisItem = $(this).text();
                $(this).addClass('borderred');
                 pleaseSelect = `Please select ${thisItem}`;
                return false; // stop loop early if any is not selected
            }
        });

        $(this).closest('.add_extra_product_popup_main').find('.option_name.selected').each(function(){
            selectedOptions.push($(this).text().trim());
        //    alert(selectedoption);
        });

        let finalResult = selectedOptions.join(" / ");

        

        if (allSelected) {

            $(this).closest('.add_extra_product_popup_inner').find('.single_variant').each(function(){
                var alltitle = $(this).attr('varianttitle');
                var allvarId = $(this).attr('variantid');
                var price = $(this).attr('variantprice');
                var ComPrice = $(this).attr('variantComPrice');
                if(alltitle == finalResult){
                   console.log(alltitle);
                   console.log(allvarId);
                   finalselectedid = allvarId;
                   pricebox.text(price);
                   pricebox.attr('prdVarPrice', price);
                   pricebox.attr('variantComPrice', ComPrice)
                }
                
            });
            
            //alert(finalResult);
            //finalSelect.text(finalResult).addClass('selected_variant').attr('variantId', finalselectedid);
             
        } else {
            // alert(pleaseSelect);
        }
    });
    $(document).on('click', '.add_extra_product_popup_main .selection_btn_material', function () {
        $('.option_name').removeClass('borderred');
        let allSelected = true;
        var pleaseSelect;
        let selectedOptions = [];
        var finalselectedid;
        var finalSelectPrice = $(this).closest('.add_extra_product_popup_inner').find('.price_extraprdadd').attr('prdvarprice');
        finalSelectPrice = finalSelectPrice.replace('£', '').replace(',', '');
        var finalSelectComPrice = $(this).closest('.add_extra_product_popup_inner').find('.price_extraprdadd').attr('variantcomprice');
        if(finalSelectComPrice){
           finalSelectComPrice = finalSelectComPrice.replace('£', '').replace(',', '');
        }
        
        // alert(finalSelectPrice);
        // alert(finalSelectComPrice);

        var finalSelect = $(this).closest('.add_extra_product_single').find('.add_extra_prd_btn');
        var singlePopup = $(this).closest('.add_extra_product_popup_main');
        var pricebox = $(this).closest('.add_extra_product_popup_main').find('.price_extraprdadd');
        $(this).closest('.add_extra_product_popup_main').find('.option_name').each(function () {
            if (!$(this).hasClass('selected')) {
                allSelected = false;
                var thisItem = $(this).text();
                $(this).addClass('borderred');
                 pleaseSelect = `Please select ${thisItem}`;
                return false; // stop loop early if any is not selected
            }
        });

        $(this).closest('.add_extra_product_popup_main').find('.option_name.selected').each(function(){
            selectedOptions.push($(this).text().trim());
        //    alert(selectedoption);
        });

        let finalResult = selectedOptions.join(" / ");

        

        if (allSelected) {

            $(this).closest('.add_extra_product_popup_inner').find('.single_variant').each(function(){
                var alltitle = $(this).attr('varianttitle');
                var allvarId = $(this).attr('variantid');
                var price = $(this).attr('variantprice');
                var ComPrice = $(this).attr('variantComPrice');
                if(alltitle == finalResult){
                   console.log(alltitle);
                   console.log(allvarId);
                   finalselectedid = allvarId;
                   pricebox.text(price);
                   pricebox.attr('prdVarPrice', price);
                   pricebox.attr('variantComPrice', ComPrice)
                }
                
            });
            
            //alert(finalResult);
            finalSelect.text(finalResult).addClass('selected_variant').attr('variantId', finalselectedid).attr('prdvarprice', finalSelectPrice).attr('prdvarcomprice', finalSelectComPrice);
            
               singlePopup.removeClass('open');
            
             
        } else {
            alert(pleaseSelect);
        }
    });

    // $(document).on('click', '#addToCart', function(){
    //        var items = [];

    //         $('.selected_variant').each(function(){
    //             var id = $(this).attr('variantid');
    //             if(id){
    //             items.push({ id: Number(id), quantity: 1 });
    //             }
    //         });

    //         if(items.length){
    //             $.post('/cart/add.js', { items: items }, function(){
    //             // alert('All products added to cart!');
    //             }, 'json');
    //         }
    // });
    

    $(document).on('mouseup', function(e) {
    // if the target of the click isn't the container
    // nor a descendant of the container
        if (!$('.add_extra_product_popup_inner').is(e.target) && 
            $('.add_extra_product_popup_inner').has(e.target).length === 0) {
            $('.add_extra_product_popup_main').removeClass('open');
        }
    });

    setInterval(() => {
        extra_prd_length = $('.add_extra_products_box .selected_variant');
        //console.log(extra_prd_length.length);
        if(extra_prd_length.length>0){

            var main_prd_price = $('#productPrice .money').text();
            main_prd_price = parseFloat(main_prd_price.replace('£', '').replace(',', '')) || 0;
            //$('#productPrice .money').text(main_prd_price);
            //console.log(main_prd_price);
            var main_prd_compare_price = $('#comparePrice .money').text();
            main_prd_compare_price = parseFloat(main_prd_compare_price.replace('£', '').replace(',', '')) || 0;
            //$('#comparePrice .money').text(main_prd_compare_price);
            //console.log(main_prd_compare_price);

            var ExtraVariantsPriceAll = 0;
            var ExtraVariantsComPriceAll = 0;
            $('.add_extra_products_box .selected_variant').each(function() {
                var ExtraVariantsPrice = parseFloat($(this).attr('prdvarprice')) || 0;
                var ExtraVariantsComPrice = parseFloat($(this).attr('prdvarcomprice')) || 0;
                ExtraVariantsPriceAll += ExtraVariantsPrice;
                ExtraVariantsComPriceAll += ExtraVariantsComPrice;
            });

            console.log("Total Extra Variants Price:", ExtraVariantsPriceAll);
            console.log("Total Extra Variants compare Price:", ExtraVariantsComPriceAll);
            var totalPrice = ExtraVariantsPriceAll + main_prd_price;
            var formattedPrice = '£' + totalPrice.toLocaleString('en-GB', { minimumFractionDigits: 2 });
            $('.total_price_box .total_price').text(formattedPrice);
            var totalComPrice = ExtraVariantsComPriceAll + main_prd_compare_price;
            var formattedComPrice = '£' + totalComPrice.toLocaleString('en-GB', { minimumFractionDigits: 2 });
            $('.total_price_box .total_compare_price').text(formattedComPrice);
            $('.pro-price_main').hide();
            $('.total_price_box').show();
 
        }
        
    }, 2000); 
    

})